import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=2c3894b2&scoped=true&"
import script from "./registration.vue?vue&type=script&lang=js&"
export * from "./registration.vue?vue&type=script&lang=js&"
import style0 from "./registration.vue?vue&type=style&index=0&lang=css&"
import style1 from "./registration.vue?vue&type=style&index=1&id=2c3894b2&scoped=true&lang=css&"
import style2 from "./registration.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3894b2",
  null
  
)

export default component.exports